import script from "./CardVault.vue?vue&type=script&setup=true&lang=js"
export * from "./CardVault.vue?vue&type=script&setup=true&lang=js"

import "./CardVault.vue?vue&type=style&index=0&id=01188510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01188510"]])

export default __exports__